import React, { Component, createRef } from 'react';
import PropTypes from 'prop-types';
import Autocomplete from '../../AutoComplete';
import { FilterTypes } from '../Components';

class AutocompleteFilter extends Component {
  constructor(props) {
    super(props);

    this.autocompleteRef = createRef();
  }

  handleChange = (selectedItem) => {
    const { item } = this.props;

    this.autocompleteRef.clear();

    this.notifyAddFilter(
      item.propertyName,
      item.queryOption,
      null,
      {
        result: selectedItem,
        props: this.props,
      },
      null,
      FilterTypes.AUTOCOMPLETE,
      item.customFilter,
    );
  };

  notifyAddFilter = (...filter) => {
    const { addFilter } = this.props;

    addFilter && addFilter(...filter);
  };

  render() {
    const {
      item,
    } = this.props;

    return (
      <div
        className="filter__campoRicerca"
        style={item.width && { width: item.width.toString() }}
      >
        <div className="autocomplete">
          <Autocomplete
            minLength={item.minLength}
            onChange={this.handleChange}
            ref={(r) => { this.autocompleteRef = r; }}
            renderProperty={item.renderProperty}
            title={item.description}
            url={item.url}
          />
        </div>
      </div>
    );
  }
}

AutocompleteFilter.propTypes = {
  /** Callback invocata all'aggiunta di un termine di filtro */
  addFilter: PropTypes.func.isRequired,
  /** Descrittore del filtro da applicare */
  item: PropTypes.shape({
    propertyName: PropTypes.string.isRequired,
  }).isRequired,
};

export default AutocompleteFilter;
